import { InputStateInterface } from 'common/module/input/state.interface';
import { InputValidatorInterface } from 'common/module/input/validator.interface';

export class InputValidatorFileType implements InputValidatorInterface {
  /**
   * Constructor
   * @param message The error message
   * @param acceptableFileType An array of string with value like 'application/pdf', 'image/jpeg'
   */
  constructor(protected message: string, private acceptableFileType: string[]) {}

  /**
   * @inheritDoc
   */
  public getError(value: File, context: { [key: string]: InputStateInterface }): string {
    return value?.type && !this.acceptableFileType.includes(value.type) ? this.message : '';
  }
}
